import { IPagination } from "@inceptionbg/ui-components";
import { axiosInstance } from "../App";
import {
  IConsentClient,
  ConsentFetchOption,
  IConsentClientItem,
  IConsentRequest,
} from "../types/IConsent";

export const getConsentClient = (clientId: string) =>
  axiosInstance
    .get(`/consent/client/${clientId}`)
    .then(({ data }) => data as IConsentClient);

export const getConsentClients = (
  farmUuid: string,
  pagination: IPagination,
  fetchOptions?: ConsentFetchOption[]
) =>
  axiosInstance
    .get(`/consent/clients`, {
      params: {
        fetchByFarmUuid: farmUuid,
        ...pagination,
        fetchOptions,
      },
    })
    .then(({ data }) => ({
      clients: data.clients as IConsentClientItem[],
      totalRows: data.totalRows as number,
    }));

export const addConsentClient = (
  farmUuid: string,
  data: Partial<IConsentClientItem>
) =>
  axiosInstance
    .post(`/farm/${farmUuid}/consent/client`, data)
    .then(({ data }) => data);

export const updateConsentClient = (clientUuid: string, active: boolean) =>
  axiosInstance
    .patch(`/farm/consent/client/${clientUuid}`, { active })
    .then(({ data }) => data);

export const getConsentRequests = (
  farmUuid: string,
  pagination: IPagination,
  fetchOptions?: ConsentFetchOption[]
) =>
  axiosInstance
    .get(`/farm/${farmUuid}/consent-requests`, {
      params: {
        ...pagination,
        fetchOptions,
      },
    })
    .then(({ data }) => ({
      requests: data.requests as IConsentRequest[],
      totalRows: data.totalRows as number,
    }));
